import Model from "./base/model";

class TransporterCteReadingEmail extends Model{
  resourceName() {
    return "transporter_cte_reading_emails";
  }

  fields() {
    return {
      transporter_id: "",
      cte_reading_email_id:"",
      action: "",
      transporter: { jsonApi: "hasOne", type: "transporter" },
      cte_reading_email: { jsonApi: "hasOne", type: "cte_reading_emails" },
    };
  }

}

export default new TransporterCteReadingEmail();
